<template>
  <div class="columns gl-list">
    <div v-for="item in products" class="column is-4">
      <product-item :product="item"/>
    </div>
  </div>
</template>

<script>
  import ProductItem from './Item'

  /**
   * Список товаров.
   */
  export default {
    name: 'product-list',

    props: {
      products: {
        type: Array,
        required: true
      }
    },

    components: {
      ProductItem
    }
  }
</script>

<style scoped lang="scss">
  .gl-list {
    flex-wrap: wrap
  }

  .gl-pagination {
    list-style: none
  }
</style>



// WEBPACK FOOTER //
// Widget.vue?6be98a02